module.exports = __webpack_public_path__ + "static/media/1.f747d424.jpg";